import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  ClassificacaoDTO,
  FiltrosDetalhesDTO,
  FiltrosRegistroDTO,
  RetornoConsultaDetalhesDTO,
  RetornoConsultaRegistrosDTO,
} from "../dto/ConsultaRegistroDTO";

@Injectable({
  providedIn: "root",
})
export class HabilTrackerService {
  private baseUrl = environment.apiTracker;

  constructor(private http: HttpClient) {}

  getToken() {
    return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnQiOiJIQUJJTF9UUkFDS0VSIn0.JnGWyqxYElzVV315Tq93hiCSP28plvwVMmXgai7Pqs4";
  }

  getClassificacoes(): Promise<ClassificacaoDTO[]> {
    return new Promise<ClassificacaoDTO[]>((resolve, reject) => {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.getToken()}`,
        "Content-Type": "application/json",
      });

      this.http
        .get<ClassificacaoDTO[]>(`${this.baseUrl}/public/classificacoes`, {
          headers,
        })
        .subscribe({
          next: (value) => {
            resolve(value);
          },
          error: (err) => {
            reject(err);
          },
        });
    });
  }

  getDadosRegistros(
    dto: FiltrosRegistroDTO
  ): Promise<RetornoConsultaRegistrosDTO> {
    return new Promise<RetornoConsultaRegistrosDTO>((resolve, reject) => {
      dto.dataInicial = new Date(dto.dataInicial.setHours(0, 0, 0));
      dto.dataFinal = new Date(dto.dataFinal.setHours(23, 59, 0));
      dto.search = dto.search.replace(/\D/g, "");
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.getToken()}`,
        "Content-Type": "application/json",
      });

      this.http
        .post<RetornoConsultaRegistrosDTO>(
          `${this.baseUrl}/public/registros`,
          dto,
          {
            headers,
          }
        )
        .subscribe({
          next: (value) => {
            resolve(value);
          },
          error: (err) => {
            reject(err);
          },
        });
    });
  }

  getDadosDetalhesRegistros(
    dto: FiltrosDetalhesDTO
  ): Promise<RetornoConsultaDetalhesDTO> {
    return new Promise<RetornoConsultaDetalhesDTO>((resolve, reject) => {
      dto.dataInicial = new Date(dto.dataInicial.setHours(0, 0, 0));
      dto.dataFinal = new Date(dto.dataFinal.setHours(23, 59, 0));
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.getToken()}`,
        "Content-Type": "application/json",
      });

      this.http
        .post<RetornoConsultaDetalhesDTO>(
          `${this.baseUrl}/public/detalhes`,
          dto,
          {
            headers,
          }
        )
        .subscribe({
          next: (value) => {
            resolve(value);
          },
          error: (err) => {
            reject(err);
          },
        });
    });
  }
}
